import store from '../../../store';
import { cloneObject } from 'smartdoors-shared/js/helpers/common';

export default function(items, source) {
    const jobsRequestOverrideItems = [];

    for(const data of items) {
        // note: 
        // the used job store actions here do not commit the changes in the store, this has to be done manually later
        // .. will be done after all items got handled, below this loop

        if(source == 'broadcast') {
            // replace job data in all stacks with the job data from the notifications since it has to be the most recent data if it came by broadcast
            store.dispatch('jobs/set', data.job);
        }

        // always add job to temp stack in case its not in the other stacks but may be needed (e.g. by notification actions)
        store.dispatch('jobs/setTemp', data.job);

        if(!data.read) {
            // set icon properties of job if notification is unread
            store.dispatch('jobs/update', {
                id: data.job.id,
                icon: 'notifications.png',
                iconClass: 'ring',
                iconPopover: this.__(`main.notifications.title.${data.typeKey}`)
            });
        } else {
            // reset icon properties of job if notification is read
            store.dispatch('jobs/update', {
                id: data.job.id,
                icon: null,
                iconClass: null,
                iconPopover: null
            });
        }

        if(data.typeKey == 'technician_request_send') {
            // if this is a job technician request notification, add this notification data persistently to the job, because we will need the data from this notification in job related components
            let existendJobOverrideData = store.state.jobs.override.find(p => p.id == data.job.id && 'jobRequestNotification' in p.overrides);
            
            const requestNotifications = existendJobOverrideData 
                ? existendJobOverrideData.overrides.jobRequestNotification.notifications.requests 
                : [];

            if(requestNotifications.findIndex(n => n.id == data.id) == -1) {
                const notification = cloneObject(data);
                delete notification.job;

                requestNotifications.push(notification)

                jobsRequestOverrideItems.push({
                    id: data.job.id,
                    notifications: {
                        'requests': requestNotifications
                    }
                });
            }
        }
    }

    if(jobsRequestOverrideItems.length) {
        store.dispatch('jobs/addOverride', {
            key: 'jobRequestNotification',
            items: jobsRequestOverrideItems
        });
    }

    // get a promise which gets resolved after the commit in the store is done
    const storeSaved = store.saved('jobs', 'commitMutations', 'notifications');

    // commit all changes in the jobs store which may have been done (with commitId 'notifications')
    store.dispatch('jobs/commit', 'notifications');

    return storeSaved;
}